import { render, staticRenderFns } from "./QuoteRecord.vue?vue&type=template&id=0ec1f64c&scoped=true"
import script from "./QuoteRecord.vue?vue&type=script&lang=js"
export * from "./QuoteRecord.vue?vue&type=script&lang=js"
import style0 from "./QuoteRecord.vue?vue&type=style&index=0&id=0ec1f64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec1f64c",
  null
  
)

export default component.exports